module.exports = __webpack_public_path__ + "static/innovation-application-web.e6d34b48.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/img/innovation-application-web.jpg
// module id = 180
// module chunks = 12729642909824 267660657819475